import { render, staticRenderFns } from "./PopupConfirmWearableConnect.vue?vue&type=template&id=39ec48fe"
import script from "./PopupConfirmWearableConnect.vue?vue&type=script&lang=js"
export * from "./PopupConfirmWearableConnect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports